module.exports = __webpack_public_path__ + "img/c42be97.jpg";